export const THREAD_SHARED = 'THREAD_SHARED';
export const THREAD_PRIVATE = 'THREAD_PRIVATE';